import React from "react";
import ExpComponent from "../components/Experience/experience";

const Experience = () => {
  return (
    <section>
      <h1 className="section-heading">Experience</h1>
      <p className="section-subheading">
        Professional roles, campus involvement, and education.
      </p>
      <ExpComponent />
    </section>
  );
};

export default Experience;
